/** Mirrors the dossier layout so the page does not reflow once data lands. */
export function TherapistDetailSkeleton() {
  return (
    <div className="animate-pulse pb-10">
      <div className="-mx-4 border-b border-border/70 px-4 py-3 sm:-mx-6 sm:px-6">
        <div className="mb-2.5 h-3 w-24 rounded bg-muted" />
        <div className="flex items-center gap-3">
          <div className="size-10 rounded-lg bg-muted" />
          <div className="space-y-2">
            <div className="h-4 w-44 rounded bg-muted" />
            <div className="h-3 w-24 rounded bg-muted" />
          </div>
        </div>
      </div>

      <div className="mt-4 space-y-4">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border bg-border sm:grid-cols-3 lg:grid-cols-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="space-y-2 bg-card px-4 pb-3 pt-3.5">
              <div className="h-2.5 w-16 rounded bg-muted" />
              <div className="h-5 w-12 rounded bg-muted" />
              <div className="h-2.5 w-20 rounded bg-muted" />
            </div>
          ))}
        </div>

        <div className="grid items-start gap-4 xl:grid-cols-[minmax(0,21rem)_minmax(0,1fr)]">
          <div className="space-y-4">
            <div className="h-72 rounded-xl border bg-card" />
            <div className="h-44 rounded-xl border bg-card" />
          </div>
          <div className="space-y-4">
            <div className="h-96 rounded-xl border bg-card" />
            <div className="h-40 rounded-xl border bg-card" />
          </div>
        </div>
      </div>
    </div>
  );
}
